<template>
    <div v-loading="isloading">
      <vxe-table empty-text="无数据！" :data="tableData">
        <vxe-column field="EquipmentId" title="微站编号"></vxe-column>
        <vxe-column field="Address" title="位置"></vxe-column>
        <vxe-column field="CreateTime" title="时间"></vxe-column>
        <vxe-column field="COD" title="化学需氧量(mg/L)"></vxe-column>
        <vxe-column field="NH3N" title="氨氮(mg/L)"></vxe-column>
        <vxe-column field="F" title="氟离子(mg/L)"></vxe-column>
        <vxe-column field="AlertMessage" title="预警信息"></vxe-column>
      </vxe-table>
      <div style="margin-bottom: 20px"></div>
      <Datatable ref="dt" tableName="MicroObservation"></Datatable>
    </div>
</template>
    <script>
        import {GetRecentlyData} from '@/api/utils';
        import Datatable from '@/components/Datatable';

        export default {
            name: 'microStation',
            components: {
                Datatable
            },
            props: {
                tableName: {
                    type: String
                }
            },
            data() {
                return {
                    isloading:true,
                    tableData: []
                }
            },
            async created() {
                let res = await GetRecentlyData().catch(() => { });
                if (res.Code === 1 && res.Data && res.Data.list) {
                    this.tableData = res.Data.list;
                }
                if(res.Data.addresses){
                  for(let i = 0; i < this.tableData.length; i++){
                    this.tableData[i]["Address"] = res.Data.addresses[i];
                  }
                }
                this.isloading = false;
            },
            mounted() {
            },
            watch: {
            },
            methods: {
            }
        }
    </script>
    <style scoped>
       
    </style>